import script from "./CContactForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CContactForm.vue?vue&type=script&setup=true&lang=ts"

import "./CContactForm.vue?vue&type=style&index=0&id=7167c0a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7167c0a6"]])

export default __exports__